/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Injectable } from '@angular/core';

/**
 * Pad the beginning of a string with a given character until it reaches the length provided
 * @param {string} string - The string to pad
 * @param {number} length - The length of the string required after padding
 * @param {string} padWith - What to pad the string with
 * @example padStart('1', 3, '0') // returns '001'
 */
export function padStart(string: string, length: number, padWith: string) {
	const pad = new Array(1 + length).join(padWith);
	return (pad + string).slice(-pad.length);
}

/**
 * Pad the beginning of a string with a given character until it reaches the length provided
 * @param {number} number - The number to pad
 * @param {number} length - The length of the string required after padding
 * @param {string} padWith - What to pad the string with
 * @example padStart('1', 3, '0') // returns '001'
 */
export function padStartNumber(number: number, length: number, padWith: string) {
	if (number.toString().length >= length) return number.toString();
	return padStart(number.toString(), length, padWith);
}

@Injectable({ providedIn: 'root' })
export class StringUtilities {
	constructor() {}

	public static generateNewGuid(): string {
		// existing GUID generator logic
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			const r = (Math.random() * 16) | 0,
				v = c === 'x' ? r : (r & 0x3) | 0x8;
			return v.toString(16);
		});
	}

	public static translateCR(source: string) {
		return source.replace(/(?:\r\n|\r|\n)/g, '<br />');
	}
}
